<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
        <span>{{"Catalogs.general_rules"|translate}}</span>
      </div>
      <button (click)="closed()">
        <mat-icon style="color: black;">close</mat-icon>
      </button>
    </div>
    <form [formGroup]="form" class="display_form">
        <div class="content custom_content">
          <div class="rule_block">
            <div class="title_block">
              <img src="assets/icones/overall-price.svg" alt="">
              {{"Catalogs.overall_discount_adj"|translate}}
            </div>
            <div class="inline_block">
              <div class="field inline_field">
                <input 
                  type="number" 
                  formControlName="general_discount" 
                  (input)="onGeneralDiscountChange($event)"
                >
                <span class="indicate_input custom_indic">%</span>
                <span class="error_ms" *ngIf="form.get('general_discount')?.touched && form.get('general_discount')?.errors">
                  {{"common.required_field" | translate}}
                </span>
              </div>
            </div>
            
          </div>
          <div class="separator"></div>
          <div class="rule_block">
            <div class="title_block">
              <img src="assets/icones/overall-quantity.svg" alt="">
              {{"Catalogs.overall_quantity_adj"|translate}}
            </div>
            <div class="inline_block">
              <div class="field">
                <input type="number" formControlName="increment" (input)="onGeneralIncrementChange($event)" (input)="sanitize($event)">
                <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                <span class="error_ms" *ngIf="form.get('increment')?.touched && form.get('increment')?.hasError('required')">
                  {{"common.required_field" | translate}}
                </span>
                <span class="error_ms"  *ngIf="form.hasError('increment')">{{ form.getError('increment') }}</span>
                <span class="error_ms"  *ngIf="form.hasError('incrementMin')">{{ form.getError('incrementMin') }}</span>
              </div>
              <div class="field">
                <input type="number" formControlName="min_qte" (change)="onGeneralMinChange($event)" (input)="sanitize($event)">
                <span class="indicate_input custom_indic">{{"Catalogs.min" | translate}}</span>
                <span class="error_ms" *ngIf="form.get('min_qte')?.touched  && form.get('min_qte')?.hasError('required')">
                  {{"common.required_field" | translate}}
                </span>
                <span class="error_ms"  *ngIf="form.hasError('minQte')">{{ form.getError('minQte') }}</span>
              </div>
              <div class="field">
                <input type="number" formControlName="max_qte" (change)="onGeneralMaxChange($event)" (input)="sanitize($event)">
                <span class="indicate_input custom_indic">{{"Catalogs.max" | translate}}</span>
                <span class="error_ms" *ngIf="form.get('max_qte')?.touched  && form.get('max_qte')?.hasError('required')">
                  {{"common.required_field" | translate}}
                </span>
                <span class="error_ms" *ngIf="form.hasError('minMax')">{{ form.getError('minMax') }}</span>
              </div>
            </div>
            <div class="inline_block">
              <div class="field">
                <label for="">{{ "Catalogs.can_be_sold_out_of_stock" | translate }}</label>
                <mat-slide-toggle formControlName="can_be_sold_out_of_stock">
                </mat-slide-toggle>
              </div>
              <div class="field">
                <label for="">{{ "Catalogs.show_stock" | translate }}</label>
                <mat-slide-toggle formControlName="show_stock">
                </mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="separator"></div>
          <div class="rule_block">
            <div class="title_block">
              <img src="assets/icones/volume.svg" alt="">
              {{"Catalogs.overall_volume_adj"|translate}}
            </div>
            <div class="inline_block">
              <div class="field">
                <input type="number" readonly>
                <span class="indicate_input custom_indic">{{"Catalogs.quantity_min"|translate}}</span>
              </div>
              <div class="field">
                <input type="number" readonly>
                <span class="indicate_input custom_indic">{{"Catalogs.quantity_max"|translate}}</span>
              </div>
              <div class="field">
                <input type="number" readonly>
                <span class="indicate_input custom_indic">{{"quotations_and_orders.price"|translate}}</span>
              </div>
            </div>
          </div>
        </div>
    </form>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" *appHasPermission="submitPermission()" (click)="save()">
        <span> {{"common.save"|translate | uppercase}} </span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
